<template>
    <div class="payment__form">
        <template
            v-if="state.currentView === 'CARD_INIT_VIEW' && state.processing != true"
        >
            <form
                v-if="state.useSavedCards === false"
                @submit.prevent="checkDetails()"
            >
                <p
                    class="container__col-md-12 container__col-sm-12 payment__instruction"
                >
                    {{ $t("card.title.description") }}
                </p>
                <primary-input
                    :title="$t('card.input.number')"
                    @value-change="collectCardNumber"
                    :total-characters="23"
                    :card="true"
                    @new-focus="handleFocus"
                    :focused="focusedField"
                    type="tel"
                    :number-only="true"
                    @completed-card="handleFocus('expiry')"
                    :isRequired="
                        getValueFromPath(state, 'inputs.cardnumber.required') || true
                    "
                    :defaultValue="
                        getValueFromPath(state, 'inputs.cardnumber.value') || null
                    "
                    inputName="cardnumber"
                    class="container__col-md-12 container__col-sm-12"
                    prefix-image="card-number-input"
                    placeholder="0000 0000 0000 0000"
                    :postfix-image="true"
                />
                <div class="container--row card--logo">
                    <div v-for="(card, i) in cardLogos" :key="i">
                        <img
                            :src="require(`@/assets/icons/card-${card}.svg`)"
                            alt="mastercard"
                        />
                    </div>
                </div>
                <div class="container--row">
                    <div class="container__col-md-7 container__col-sm-7">
                        <primary-input
                            :title="$t('card.input.validity')"
                            @value-change="validTill = $event"
                            :total-characters="5"
                            :date="true"
                            type="tel"
                            :focused="focusedField"
                            @new-focus="handleFocus"
                            @completed-date="handleFocus('cvv')"
                            :number-only="true"
                            inputName="expiry"
                            :isRequired="
                                getValueFromPath(state, 'inputs.expiry.required') || true
                            "
                            :defaultValue="
                                getValueFromPath(state, 'inputs.expiry.value') || null
                            "
                            class="container__col-md-12 container__col-sm-12"
                            prefix-image="card-number-input"
                            placeholder="MM/YY"
                        />
                    </div>
                    <div class="container__col-md-5 container__col-sm-5">
                        <primary-input
                            title="CVV"
                            :info="$t('card.cvv.info')"
                            :postfix-label-image="'cvv-info-' + state.locale + '.svg'"
                            @value-change="cvv = $event"
                            @show-modal="showCVVInfo"
                            :modalOpen="modalOpen"
                            @new-focus="handleFocus"
                            :total-characters="4"
                            inputName="cvv"
                            :focused="focusedField"
                            :number-only="true"
                            type="password"
                            inputmode="numeric"
                            :isRequired="
                                getValueFromPath(state, 'inputs.cvv.required') || true
                            "
                            :defaultValue="
                                getValueFromPath(state, 'inputs.cvv.value') || null
                            "
                            class="container__col-md-12 container__col-sm-12 cvv"
                            prefix-image="cvv"
                            placeholder="123"
                        />
                    </div>
                    <div
                        class=" container--row container__col-md-12 container__col-sm-12 remember__wrapper"
                    >
                        <label for="" v-if="adaptStateToDevice()" class="checkbox">
                            <span class="checkbox__input">
                                <input
                                    type="checkbox"
                                    v-model="rememberMe"
                                    id="checkbox"
                                    name="checkbox"
                                />
                                <span class="checkbox__control">
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 24 24"
                                        aria-hidden="true"
                                        focusable="false"
                                    >
                                        <path
                                            fill="none"
                                            stroke="currentColor"
                                            stroke-width="3"
                                            d="M1.73 12.91l6.37 6.37L22.79 4.59"
                                        />
                                    </svg>
                                </span>
                            </span>
                        </label>
                        <label class="" for="checkbox">{{ $t("card.checkbox.remember") }}</label>
                        <div v-if="!adaptStateToDevice()" class="switch">
                            <input
                                id="checkbox"
                                type="checkbox"
                                v-model="rememberMe"
                                class="switch-input"
                            />
                            <label for="checkbox" class="switch-label">{{ $t("card.checkbox.switch") }}</label>
                        </div>
                    </div>
                    <div
                        v-if="rememberMe"
                        class="container__col-md-12 container__col-sm-12"
                    >
                        <div class="container__col-md-12 container__col-sm-12">
                            <primary-input
                                :title="$t('card.input.phone')"
                                type="tel"
                                :number-only="true"
                                inputName="rememberPhone"
                                class="container__col-md-12 container__col-sm-12"
                                prefix-image="smart-phone"
                                placeholder="07013926478"
                                :defaultValue="
                                    getValueFromPath(state, 'inputs.rememberPhone.value') || null
                                "
                                :isRequired="
                                    getValueFromPath(state, 'inputs.rememberPhone.required') ||
                                        true
                                "
                                @value-change="telephone = $event"
                            />
                        </div>
                        <div class="container__col-md-12 container__col-sm-12">
                            <primary-input
                                :title="$t('card.input.email')"
                                class="container__col-md-12 container__col-sm-12"
                                prefix-image="user"
                                placeholder="ted@lade.com"
                                inputName="rememberEmail"
                                type="email"
                                :defaultValue="
                                    getValueFromPath(state, 'inputs.rememberEmail.value') || null
                                "
                                :isRequired="
                                    getValueFromPath(state, 'inputs.rememberEmail.required') ||
                                        true
                                "
                                @value-change="email = $event"
                            />
                        </div>
                    </div>
                </div>
                <PrimaryButton
                    :disabled="!hasCompletedFields"
                    type="submit"
                    :content="
                        [
                            $t('ui.pay.btn'), 
                            state.dcc ? state.dcc.to : state.currency, 
                            state.dcc ? formatMoney(state.dcc.charge_amount) :
                            formatMoney(state.amount.toLocaleString())
                        ]
                            .filter(Boolean)
                            .join(' ')
                    "
                />
                <div class="container--row container__col-md-12 container__col-sm-12 another-saved">
                    <button
                        v-if="state.hasSavedCards"
                        type="button"
                        aria-label="Use saved card"
                        class="payment__another"
                        role="button"
                        aria-pressed="false"
                        @click="switchView"
                    >
                        {{ $t("card.saved.description") }}
                    </button>
                </div>
            </form>
            <form
                v-else-if="state.hasSavedCards === true && state.useSavedCards === true"
            >
                <p
                    class="container__col-md-12 container__col-sm-12 payment__instruction"
                >
                    {{ $t("card.preference.description") }}
                </p>
                <ul class="saved-card-list">
                    <li v-for="(card, index) in state.savedCards" :key="index">
                        <button
                            type="button"
                            role="button"
                            aria-label="saved card"
                            class="saved-card"
                            @click="useCard(card)"
                        >
                            <img
                                v-if="card.brand === 'MASTERCARD'"
                                :src="require('@/assets/icons/mastercard.svg')"
                                alt="mastercard"
                            />
                            <img
                                v-else-if="card.brand === 'VISA'"
                                :src="require('@/assets/icons/new-visa.svg')"
                                alt="visa card"
                            />
                            <img
                                v-else
                                :src="require('@/assets/icons/othercard.svg')"
                                alt="other card"
                            />
                            <label for="saved card"> {{ card.masked_pan }}</label>
                        </button>
                        <button class="remove-btn" type="button" @click="deleteCard(card)">
                            <svg
                                width="24"
                                height="24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M10.427 7.872h3.147v-1.06h-3.147v1.06Zm12.972-1.979c-.506-2.72-2.642-4.8-5.31-5.307A31.613 31.613 0 0 0 12.002 0c-2.055 0-4.11.187-6.138.586C3.143 1.093 1.088 3.2.58 5.866a32.42 32.42 0 0 0 0 12.214 6.59 6.59 0 0 0 5.285 5.308c2.028.426 4.083.613 6.138.613 2.055 0 4.083-.187 6.112-.587 2.723-.534 4.778-2.614 5.284-5.307.801-4.054.801-8.187 0-12.214ZM16.115 16.88a1.31 1.31 0 0 1-1.309 1.31H9.194a1.31 1.31 0 0 1-1.308-1.31v-6.555a.5.5 0 1 1 1 0v6.555c0 .17.138.31.308.31h5.612a.31.31 0 0 0 .31-.31v-6.555a.5.5 0 1 1 1 0v6.555Zm-5.676-1.214v-5.34a.5.5 0 1 1 1 0v5.34a.5.5 0 1 1-1 0Zm2.123 0v-5.34a.5.5 0 1 1 1 0v5.34a.5.5 0 1 1-1 0Zm4.088-6.793h-9.3a.5.5 0 1 1 0-1h2.077v-1.56a.5.5 0 0 1 .5-.5h4.147a.5.5 0 0 1 .5.5v1.56h2.076a.5.5 0 1 1 0 1Z"
                                    fill="#EB5757"
                                />
                            </svg>
                        </button>
                    </li>
                </ul>
                <div class="container--row container__col-md-12 container__col-sm-12 another-saved">
                    <button
                        type="button"
                        class="payment__another"
                        role="button"
                        aria-label="use another card"
                        aria-pressed="false"
                        @click="switchView"
                    >
                        {{ $t("card.select.alternative") }}
                    </button>
                </div>
                <base-modal
                    v-if="showModal"
                    @close="toggleModal"
                    class="modal-container"
                >
                    <div class="modal-header">
                        <svg preserveAspectRatio="xMinYMin meet" fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40"><path d="M38.999 9.822c-.845-4.533-4.404-8-8.852-8.845A52.69 52.69 0 0 0 20.006 0C16.58 0 13.155.312 9.775.977c-4.537.845-7.962 4.356-8.808 8.8a54.035 54.035 0 0 0 0 20.357c.845 4.578 4.36 8 8.808 8.845 3.38.71 6.805 1.022 10.23 1.022 3.425 0 6.805-.312 10.186-.978 4.538-.889 7.963-4.356 8.808-8.844a52.245 52.245 0 0 0 0-20.357Z" fill="#F9C8C8"/><path d="M16 14v-2a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2m-13 0h18-18Zm2 0v14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V14H13Zm9 5v6m-4-6v6" stroke="#C91818" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
                        <button type="button" @click="showModal = false">
                            <svg
                                width="16"
                                height="16"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M8 15.384A7.384 7.384 0 1 0 8 .616a7.384 7.384 0 0 0 0 14.768Z"
                                    fill="#F9C8C8"
                                />
                                <path
                                    d="M9.792 10.59a.618.618 0 0 0 .876 0 .62.62 0 0 0 0-.877L8.915 7.96l1.754-1.753a.62.62 0 1 0-.876-.877L8.039 7.084 6.285 5.33a.62.62 0 1 0-.877.877L7.162 7.96 5.41 9.713a.62.62 0 1 0 .877.877l1.753-1.753 1.753 1.753Z"
                                    fill="#C91818"
                                />
                            </svg>
                        </button>
                    </div>
                    <h1>{{ $t("card.delete.btn") }}</h1>
                    <p class="delete-info">
                        {{ $t("card.delete.info") }} {{ selectedCard.masked_pan }}.
                    </p>

                    <p class="delete-question">{{ $t("card.delete.question") }}</p>
                    <div class="modal-cta">
                        <button
                            class="modal-cta-cancel"
                            @click="showModal = false"
                            type="button"
                        >
                            {{ $t("card.delete.cancel") }}
                        </button>
                        <button
                            class="modal-cta-delete"
                            type="button"
                            @click="removeSavedCard(selectedCard)"
                        >
                            {{ $t("card.delete.action") }}
                            <svg
                                width="16"
                                height="16"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <g
                                    clip-path="url(#a)"
                                    stroke="#fff"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                >
                                    <path
                                        d="M5.333 4.001V2.668c0-.737.597-1.334 1.334-1.334h2.666c.737 0 1.334.597 1.334 1.334V4M2 4.001h12H2Zm1.333 0v9.333c0 .737.597 1.334 1.334 1.334h6.666c.737 0 1.334-.597 1.334-1.334V4.001H3.333ZM9.333 7.334v4M6.667 7.334v4"
                                    />
                                </g>
                                <defs>
                                    <clipPath id="a">
                                        <path
                                            fill="#fff"
                                            transform="translate(0 .001)"
                                            d="M0 0h16v16H0z"
                                        />
                                    </clipPath>
                                </defs>
                            </svg>
                        </button>
                    </div>
                </base-modal>
            </form>
        </template>
        <template  v-else-if="
            state.currentView == 'PAYMOB_INIT_VIEW' && state.processing != true
        ">
            <form @submit.prevent="checkAddress()">
                <p class="container__col-md-12 container__col-sm-12 payment__instruction">
                    Enter your details to pay.
                </p>
                <primary-input
                    :title="$t('card.cardholder.name')"
                    @value-change="cardholdername = $event"
                    :isRequired="getValueFromPath(state, 'inputs.card_holder_name.required') || true"
                    inputName="cardholdername"
                    class="container__col-md-12 container__col-sm-12"
                    prefix-image="user"
                    placeholder="John Doe"
                    :cardname="true"
                    :postfix-image="false"
                />
                <primary-input
                    :title="$t('card.input.phone')"
                    type="tel"
                    :number-only="true"
                    inputName="telephone"
                    class="container__col-md-12 container__col-sm-12"
                    prefix-image="smart-phone"
                    placeholder="7013926478"
                    :isRequired="getValueFromPath(state, 'inputs.phonenumber.required') || true"
                    @value-change="telephone = $event"
                />
                <primary-input
                    :title="$t('card.auth.input.address')"
                    @value-change="address = $event"
                    :isRequired="getValueFromPath(state, 'inputs.billing_address.required') || true"
                    inputName="address"
                    class="container__col-md-12 container__col-sm-12"
                    prefix-image="location"
                    placeholder="20 Saltlake Edorado"
                    :postfix-image="false"
                />
                <div class="container--row">
                    <div class="container__col-md-8 container__col-sm-8">
                        <primary-input
                            :title="$t('card.auth.input.city')"
                            @value-change="city = $event"
                            :date="false"
                            inputName="city"
                            :isRequired="
                                getValueFromPath(state, 'inputs.billing_city.required') || true
                            "
                            class="container__col-md-12 container__col-sm-12"
                            prefix-image="building"
                            placeholder="New Cairo"
                        />
                    </div>
                    <div class="container__col-md-4 container__col-sm-4">
                        <primary-input
                            :title="$t('card.auth.input.state')"
                            @value-change="userState = $event"
                            inputName="state"
                            :isRequired="getValueFromPath(state, 'inputs.billing_state.required') || true"
                            class="container__col-md-12 container__col-sm-12"
                            prefix-image="state"
                            placeholder="EG-C"
                        />
                    </div>
                </div>
                <div class="container--row">
                    <div class="container__col-md-8 container__col-sm-8">
                        <primary-select
                            :title="$t('card.auth.input.country')"
                            @value-change="country = $event"
                            inputName="country"
                            :options="state.isoCountryOptions"
                            :for-country="true"
                            :isRequired="
                                getValueFromPath(state, 'inputs.billing_country.required') || true
                            "
                            class="container__col-md-12 container__col-sm-12"
                            prefix-image="globe"
                            placeholder="EG"
                        />
                    </div>
                    <div class="container__col-md-4 container__col-sm-4">
                        <primary-input
                            :title="$t('card.auth.input.zip')"
                            @value-change="zip = $event"
                            :date="false"
                            inputName="zip"
                            type="tel"
                            :isRequired="getValueFromPath(state, 'inputs.billing_zip.required') || true"
                            class="container__col-md-12 container__col-sm-12"
                            prefix-image="zip-code"
                            placeholder="928302"
                        />
                    </div>
                </div>
                <PrimaryButton
                    :content="
                        ['Pay', state.currency, state.amount.toLocaleString()]
                            .filter(Boolean)
                            .join(' ')
                    "
                    type="submit"
                    :disabled="!hasCompletedDetails"
                />
            </form>
        </template>
        <form
            v-else-if="
                state.currentView == 'REDIRECT_VIEW' && state.processing != true
            "
        >
            <div class="redirect-wrapper">
                <img
                    class="redirect-icon"
                    :src="require('@/assets/icons/redirect.svg')"
                    alt="redirect-icon"
                />
            </div>
        
            <p class="container__col-md-12 container__col-sm-12 payment__instruction">
                {{ $t("card.redirect.description")}}
            </p>
            <PrimaryButton :content="$t('ui.redirect.btn')" @click="Next" />
        </form>
        <form
            v-else-if="
                state.currentView == 'CARD_AUTH_VIEW' && state.auth == 'PIN' && state.processing != true
            "
        >
            <h5
                class="container__col-md-12 container__col-sm-12 payment__instruction"
            >
                {{ $t("card.noauth.input.pin")}}
            </h5>
            <pin-input inputName="" @value-complete="validatePin" :index-value="1" />
        </form>
        <form
            v-if="
                state.currentView == 'CARD_AUTH_VIEW' && state.auth == 'AVS' && state.processing != true
            "
            @submit.prevent="checkAddress()"
        >
            <p class="container__col-md-12 container__col-sm-12 payment__instruction">
                {{ $t("card.auth.address.title")}}
            </p>
            <primary-input
                :title="$t('card.cardholder.name')"
                @value-change="cardholdername = $event"
                :isRequired="getValueFromPath(state, 'inputs.card_holder_name.required') || true"
                inputName="cardholdername"
                class="container__col-md-12 container__col-sm-12"
                prefix-image="user"
                placeholder="John Doe"
                :cardname="true"
                :postfix-image="false"
            />
            <primary-input
                :title="$t('card.input.phone')"
                type="tel"
                :number-only="true"
                inputName="telephone"
                class="container__col-md-12 container__col-sm-12"
                prefix-image="smart-phone"
                placeholder="01 234 56"
                :isRequired="getValueFromPath(state, 'inputs.phonenumber.required') || true"
                @value-change="telephone = $event"
            />
            <primary-input
                :title="$t('card.auth.input.address')"
                @value-change="address = $event"
                :isRequired="getValueFromPath(state, 'inputs.address.required') || true"
                inputName="address"
                class="container__col-md-12 container__col-sm-12"
                prefix-image="location"
                placeholder="20 Saltlake Edorado"
                :postfix-image="false"
            />
            <div class="container--row">
                <div class="container__col-md-8 container__col-sm-8">
                    <primary-input
                        :title="$t('card.auth.input.city')"
                        @value-change="city = $event"
                        :date="false"
                        inputName="city"
                        :isRequired="
                            getValueFromPath(state, 'inputs.city.required') || true
                        "
                        class="container__col-md-12 container__col-sm-12"
                        prefix-image="building"
                        placeholder="Livingson"
                    />
                </div>
                <div class="container__col-md-4 container__col-sm-4">
                    <primary-input
                        :title="$t('card.auth.input.state')"
                        @value-change="userState = $event"
                        inputName="state"
                        :isRequired="getValueFromPath(state, 'inputs.cvv.required') || true"
                        class="container__col-md-12 container__col-sm-12"
                        prefix-image="state"
                        placeholder="CA"
                    />
                </div>
            </div>
            <div class="container--row">
                <div class="container__col-md-8 container__col-sm-8">
                    <!-- <primary-input
                        title="COUNTRY"
                        @value-change="country = $event"
                        inputName="country"
                        :isRequired="
                            getValueFromPath(state, 'inputs.country.required') || true
                        "
                        class="container__col-md-12 container__col-sm-12"
                        prefix-image="globe"
                        placeholder="US"
                    /> -->
                    <primary-select
                        :title="$t('card.auth.input.country')"
                        :description-text="$t('ui.input.choose')"
                        @value-change="country = $event"
                        inputName="country"
                        :options="state.isoCountryOptions"
                        :for-country="true"
                        :isRequired="
                            getValueFromPath(state, 'inputs.country.required') || true
                        "
                        class="container__col-md-12 container__col-sm-12"
                        prefix-image="globe"
                        placeholder="US"
                    />
                </div>
                <div class="container__col-md-4 container__col-sm-4">
                    <primary-input
                        :title="$t('card.auth.input.zip')"
                        @value-change="zip = $event"
                        :date="false"
                        inputName="zip"
                        :isRequired="getValueFromPath(state, 'inputs.zip.required') || true"
                        class="container__col-md-12 container__col-sm-12"
                        prefix-image="zip-code"
                        placeholder="928302"
                    />
                </div>
            </div>
            <PrimaryButton
                :content="
                    [$t('ui.pay.btn'), state.currency, state.amount.toLocaleString()]
                        .filter(Boolean)
                        .join(' ')
                "
                type="submit"
            />
        </form>
        <form
            v-else-if="
                state.currentView == 'CARD_OTP_VIEW' && state.processing !== true
            "
            @submit.prevent="submitOtp"
        >
            <p class="container__col-md-12 container__col-sm-12 payment__instruction">
                {{ $t("card.otp.instruction")}}
            </p>
            <primary-input
                :title="$t('card.otp.input.pin')"
                class="container__col-md-12 container__col-sm-12 card-otp"
                prefix-image="password"
                placeholder="123456"
                type="password"
                input-name="otp"
                inputmode="numeric"
                :isRequired="getValueFromPath(state, 'inputs.otp.required') || true"
                @value-change="otp = $event"
            />
            <PrimaryButton :content="$t('card.otp.confirm.btn')" type="submit" />

            <div class="container--row container__col-md-12 container__col-sm-12 another-saved">
                <button
                    :disabled="!state.canResendOtp"
                    type="button"
                    aria-label="resend OTP"
                    :class="state.canResendOtp === false ? 'resend-disabled' : 'payment__another'"
                    role="button"
                    aria-pressed="false"
                    @click="resendOtp"
                >
                    {{ $t("card.otp.resend.btn")}}
                </button>
            </div>
        </form>

        <form
            v-else-if="
                state.currentView == 'CARD_MOBILE_NUMBER_VIEW' && state.processing !== true
            "
            @submit.prevent="submitPhoneForOTP"
        >
            <p class="container__col-md-12 container__col-sm-12 payment__instruction">
                {{ state.instructions }}
            </p>
            <div class="container__col-md-12 container__col-sm-12">
                <primary-input
                    :title="$t('card.input.phone')"
                    type="tel"
                    :number-only="true"
                    inputName="phoneForOTP"
                    class="container__col-md-12 container__col-sm-12"
                    prefix-image="smart-phone"
                    placeholder="07013926478"
                    :defaultValue="null"
                    :isRequired="true"
                    @value-change="phoneForOTP = $event"
                />
            </div>
            <PrimaryButton content="Authorize Payment" type="submit" />
        </form>

        <section v-if="!adaptStateToDevice() && modalOpen" class="cvv-info__popup">
            <img
                class="cvv-info__img"
                :src="require('@/assets/img/cvv-image.svg')"
                :alt="$t('card.cvv.info')"
            />
            <h4 class="cvv-info__main">{{ $t("card.cvv.title") }}</h4>
            <p class="cvv-info__sub">
                {{ $t("card.cvv.instruction")}}
            </p>
            <div class="cvv-info__btn-wrapper">
                <button @click="modalOpen = false" type="button" class="cvv-info__btn">
                    {{ $t("card.cvv.close.btn")}}
                </button>
            </div>
        </section>
    </div>
</template>

<script>
import { ref, onBeforeUnmount, watch, computed, provide } from "vue";
import { injectStore, mapState } from "redux-vuex";
import { getValueFromPath, formatMoney, isValidPhoneNumber } from "@/support/helpers";

import PrimaryInput from "@/components/form/base-input";
import PrimaryButton from "@/components/form/base-button.vue";
import PinInput from "@/components/form/base-pin-input";
import BaseModal from "@/components/base-modal";
import PrimarySelect from "@/components/form/base-select";
import { useI18n } from "vue-i18n";

export default {
    name: "CardPayment",
    components: {
        PinInput,
        PrimaryButton,
        PrimaryInput,
        BaseModal,
        PrimarySelect,
    },
    emits: ["error-message"],
    // eslint-disable-next-line vue/no-setup-props-destructure
    setup(props, { emit }) {
        const { t } = useI18n();
        const store = injectStore();
        const transactionSuccessful = ref(false);
        const cardNumber = ref("");
        const validTill = ref("");
        const cvv = ref("");
        const pin = ref("");
        const checkoutData = ref(store.getState());
        const email = ref("");
        const telephone = ref("");
        const otp = ref("");
        const phoneForOTP = ref("");
        const address = ref("");
        const city = ref("");
        const cardholdername = ref("");
        const userState = ref("");
        const zip = ref("");
        const country = ref("");
        const focusedField = ref("cardnumber");
        const modalOpen = ref(false);
        const cardError = ref(false);
        const errorMessage = ref("");
        const selectedCard = ref();
        const showModal = ref(false);
        const rememberMe = ref(
            getValueFromPath(
                checkoutData.value,
                "view.context.inputs.remember.value",
            ) || false,
        );
        const cardLogos = ref(["discover", "visa", "amex", "mastercard", "verve", "dinersclub", "afrigo"]);

        const focusedPin = ref(1);

        const subscription = store.subscribe(() => {
            checkoutData.value = store.getState();
        });
        const hasCompletedFields = computed(() => {
            let completed = false;
            if (cardNumber.value != "" && validTill.value != "" && cvv.value != "") {
                completed = true;
                // if( rememberMe.value){if(email.value != "" & telephone.value != "") { } }
                // else{
                //     completed = true;
                // }
            }
            return completed;
        });
        const hasCompletedAddress = computed(() => {
            let completed = false;
            if (address.value != "" && city.value != "" && userState.value != "" && zip.value != "" && country.value != "") {
                completed = true;
            }
            return completed;
        });
        const hasCompletedDetails = computed(() => {
            let completed = false;
            if (address.value != "" && city.value != "" && userState.value != "" && zip.value != "" && country.value != "" && cardholdername.value && telephone.value != "") {
                completed = true;
            }
            return completed;
        });

        function checkDetails() {
            if (hasCompletedFields.value) {
                cardError.value = false;
                errorMessage.value = "";
                if (isValidCardNumber(cardNumber.value.split(" ").join(""))) {
                    cardError.value = false;
                    errorMessage.value = "";
                    if (isValidExpiry(validTill.value)) {
                        cardError.value = false;
                        errorMessage.value = "";
                        if (rememberMe.value) {
                            cardError.value = false;
                            errorMessage.value = "";
                            const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/i;
                            if (email.value == "" || telephone.value == "") {
                                cardError.value = `true-${new Date().getTime()}`;
                                errorMessage.value = "Please fill all input fields correctly.";
                                return;
                            }
                            else if (!email.value.match(EMAIL_REGEX)) {
                                cardError.value = `true-${new Date().getTime()}`;
                                errorMessage.value = t("card.invalid.email");
                                return;
                            }
                            else {
                                step2();
                            }
                        }
                        else step2();
                    } 
                    else {
                        cardError.value = `true-${new Date().getTime()}`;
                        errorMessage.value = t("card.invalid.date");
                        return;
                    }
                }
                else {
                    cardError.value = `true-${new Date().getTime()}`;
                    errorMessage.value = t("card.invalid.cardnumber");
                    return;
                }
            }
        }

        function isValidCardNumber(cardNumber) {
            return !_luhnoffset(cardNumber);
        }

        function isValidExpiry(expiryDate) {
            const date = new Date();
            const year = Number(String(date.getFullYear()).substring(2));
            let month = Number(String((date.getMonth()) + 1));
            let day = new Date().getDay() + 1;
  
            const plusTenYears = Number(String(new Date(year + 10, month, day).getFullYear()).substring(2));
  
            let expiryYear = Number(expiryDate.split("/")[1]);
            let expiryMonth = Number(expiryDate.split("/")[0]);

            if (expiryMonth > 12) {
                return false;
            }

            if (expiryYear > plusTenYears) {
                return false;
            }

            if (year > expiryYear) {
                return false;
            }

            if (year === expiryYear) {
                // Current year => check if month entered is in the past
                if (expiryMonth < month) {
                    return false;
                }
            }

            return true;
        }

        function checkAddress() {
            let data = {
                billing_address: address.value, 
                billing_city: city.value, 
                billing_country: country.value, 
                billing_state: userState.value, 
                billing_zip: zip.value,
                card_holder_name: cardholdername.value,
                phonenumber: telephone.value,
            };

            let trimmedPhoneNumber = data.phonenumber.replace(/\s/g, "").replace(/[()]/g, "");
            // eslint-disable-next-line no-useless-escape
            const specialChars = /[`!@#$%^&*()_+\\=\[\]{};':"\\|<>\\?~]/;
            if (specialChars.test(data.billing_address)) {
                cardError.value = "true-address";
                errorMessage.value = "Address should not contain only special characters.";
            }
            else if (specialChars.test(data.billing_city)) {
                cardError.value = "true-city";
                errorMessage.value = "City should not contain only special characters.";
            }
            else if (specialChars.test(data.billing_state)) {
                cardError.value = "true-state";
                errorMessage.value = "State should not contain only special characters.";
            }
            // else if (specialChars.test(data.card_holder_name)) {
            //     cardError.value = "true-cardholdername";
            //     errorMessage.value = "Cardholder name should not contain only special characters.";
            // }
            else if (!isValidPhoneNumber(trimmedPhoneNumber, 5)) {
                cardError.value = "true-phonenumber";
                errorMessage.value = "Phone number can not be less than 5 digits.";
            }
            else {
                cardError.value = false;
                data.phonenumber = trimmedPhoneNumber;
                errorMessage.value = "";
                updateRuntimeData(data);
            }
        }

        function switchView() {
            checkoutData.value.view.context.$actions.switch();
        }
        function useCard(card) {
            checkoutData.value.view.context.$actions.update({ savedcard: card });
            setTimeout(() => {
                checkoutData.value.view.context.$actions.next();
            }, 0);
        }
        watch(rememberMe, (newVal, OldVal) => {
            if (newVal !== OldVal) {
                checkoutData.value.view.context.$actions.update({ remember: newVal });
            }
        });
        watch(cardError, (newVal, OldVal) => {
            if (newVal !== OldVal) {
                emit("error-message", errorMessage.value);
            }
        });
        watch(() => checkoutData.value, (newData) => {
            if (newData) {
                cardError.value = false;
            }
        });
        function submitOtp() {
            checkoutData.value.view.context.$actions.update({ otp: otp.value });
            Next();
        }
        function submitPhoneForOTP() {
            checkoutData.value.view.context.$actions.update({ otp: phoneForOTP.value });
            Next();
        }

        function step2() {
            const data = {
                cardnumber: (cardNumber.value || "").replace(/\s+/g, ""),
                cvv: cvv.value,
                expiry: validTill.value,
            };
            if (rememberMe.value === true) {
                data.rememberEmail = email.value;
                data.rememberPhone = telephone.value;
            }
            updateRuntimeData(data);
        }
        function Next() {
            setTimeout(() => {
                checkoutData.value.view.context.$actions.next();
            }, 0);
        }
        function showCVVInfo(e) {
            if (e) {
                modalOpen.value = e;
            }
            else {
                modalOpen.value = false;
            }
        }
        function _luhnoffset(cardNumber) {
            return (_luhnsum(cardNumber) * 9) % 10;
        }
        function _luhnsum(cardNumber) {
            const digits = Array.from(String(cardNumber), Number);
            const checkDigit = digits.pop();

            return digits.reverse().reduce((sum, digit, index) => {
                if (++index & 1) {
                    (digit <<= 1) > 9 && (digit -= 9);
                }

                return sum + digit;
            }, checkDigit);
        }
        function toggleModal() {
            showModal.value = !showModal.value;
        }
        function removeSavedCard(card) {
            toggleModal();
            checkoutData.value.view.context.removeSavedCard(card.hash);
        }
        function deleteCard(card) {
            toggleModal();
            this.selectedCard = card;
        }
        function resendOtp() {
            checkoutData.value.view.context.resendOTP();
        }
        function validatePin(e) {
            pin.value = e;
            checkoutData.value.view.context.$actions.update({ pin: pin.value });
            Next();
        }
        function handleFocus(e) {
            if (e === "cvv") {
                if (cardNumber.value && cardNumber.value.length >= 16) {
                    focusedField.value = e;
                }
            } 
            else focusedField.value = e;
        }
        function collectCardNumber(e) {
            cardNumber.value = e;
            const data = {
                cardnumber: (cardNumber.value || "").replace(/\s+/g, ""),
            };
            if (data.cardnumber.length === 6 || data.cardnumber.length >= 13 || cardNumber.value === "") {
                checkoutData.value.view.context.$actions.update(data);
            }
            if (data.cardnumber.length < 6) {
                checkoutData.value.view.context.removeCardType();
            }
        }
        function updateRuntimeData(data) {
            checkoutData.value.view.context.$actions.update(data);
            Next();
        }

        provide(
            "cardError",
            computed(() => errorMessage.value),
        );
        onBeforeUnmount(() => {
            cardError.value = false;
            errorMessage.value = "";
            emit("error-message", errorMessage.value);
            subscription();
        });
        return {
            state: mapState({
                currency: (state) =>
                    getValueFromPath(state, "currency.current") || null,
                amount: (state) => getValueFromPath(state, "amount") || null,
                dcc: (state) => getValueFromPath(state, "dcc") || null,
                processing: (state) => getValueFromPath(state, "processing") || false,
                currentView: (state) => getValueFromPath(state, "view.current") || null,
                inputs: (state) => getValueFromPath(state, "view.context.inputs") || {},
                auth: (state) => getValueFromPath(state, "view.context.auth") || null,
                hasSavedCards: (state) =>
                    getValueFromPath(state, "view.context.hasSavedCard") || false,
                instructions: (state) =>
                    getValueFromPath(state, "view.context.instructions") || null,
                useSavedCards: (state) =>
                    getValueFromPath(state, "view.context.useSavedCard") || false,
                savedCards: (state) =>
                    getValueFromPath(state, "view.context.$cards") || [],
                canResendOtp: (state) =>
                    getValueFromPath(state, "view.context.canResendOTP") || false,
                isoCountryOptions: (state) =>
                    getValueFromPath(state, "view.context.inputs.billing_country.options") || [], 
                locale: (state) => getValueFromPath(state, "locale") || "en",
            }),
            step2,
            checkoutData,
            cardNumber,
            validTill,
            cvv,
            pin,
            otp,
            phoneForOTP,
            country,
            city,
            userState,
            zip,
            address,
            telephone,
            email,
            cardholdername,
            cardError,
            deleteCard,
            errorMessage,
            hasCompletedFields,
            hasCompletedAddress,
            hasCompletedDetails,
            useCard,
            focusedField,
            handleFocus,
            collectCardNumber,
            updateRuntimeData,
            removeSavedCard,
            resendOtp,
            switchView,
            submitOtp,
            submitPhoneForOTP,
            checkDetails,
            checkAddress,
            rememberMe,
            isValidCardNumber,
            focusedPin,
            validatePin,
            showCVVInfo,
            modalOpen,
            showModal,
            selectedCard,
            toggleModal,
            transactionSuccessful,
            getValueFromPath,
            formatMoney,
            Next,
            cardLogos,
        };
    },
};
</script>

<style lang="scss" scoped>
.email-error {
  font-size: 12px;
  color: red;
  margin-bottom: 10px;
}
.checkbox {
  margin-right: 8px;
  display: grid;
  grid-template-columns: min-content auto;
  grid-gap: 0.5em;
  font-size: 2rem;
  color: #FF9B00;
}

.checkbox__control {
  display: inline-grid;
  width: 1em;
  height: 1em;
  border-radius: 0.25em;
  border: 0.1em solid currentColor;

  svg {
    transition: transform 0.1s ease-in 25ms;
    transform: scale(0);
    transform-origin: bottom left;
  }
}

.checkbox__input {
  display: grid;
  grid-template-areas: "checkbox";

  > * {
    grid-area: checkbox;
  }

  input {
    opacity: 0;
    z-index: 999;
    width: 1em;
    height: 1em;
    &:focus + .checkbox__control {
      box-shadow: 0 0 0 0.05em #fff, 0 0 0.15em 0.1em currentColor;
    }

    &:checked + .checkbox__control svg {
      transform: scale(1);
    }
  }
}
.switch {
  position: relative;
  display: inline-block;
}
.switch-input {
  display: none;
}
.switch-label {
  display: block;
  width: 4.2rem;
  height: 2.3rem;
  text-indent: -150%;
  clip: rect(0 0 0 0);
  color: transparent;
  user-select: none;
}
.switch-label::before,
.switch-label::after {
  content: "";
  display: block;
  position: absolute;
  cursor: pointer;
}
.switch-label::before {
  width: 100%;
  height: 100%;
  background-color: #e0e0e0;
  border-radius: 9999em;
  -webkit-transition: background-color 0.25s ease;
  transition: background-color 0.25s ease;
}
.switch-label::after {
  top: 0.13rem;
  left: 0;
  width: 2rem;
  height: 2rem;
  border-radius: 50%;
  background-color: $white;
  box-shadow: 0px 5.06671px 5.06671px rgba(0, 0, 0, 0.15);
  // box-shadow: 0 0 2px rgba(0, 0, 0, 0.45);
  -webkit-transition: left 0.25s ease;
  transition: left 0.25s ease;
}
.switch-input:checked + .switch-label::before {
  background-color: $primary-color;
}
.switch-input:checked + .switch-label::after {
  left: 2.4rem;
}
.modal-container {
  .modal {
    &-header {
      display: flex;
      justify-content: space-between;
      margin-bottom: 2.5rem;
      @include screen(menner) {
        margin-bottom: 3.2rem;
      }
      svg{
          width: 2rem;
      }
    }
    &-cta {
      display: flex;
      justify-content: flex-end;
      font-weight: $font-medium;
      font-size: 1.4rem;
      line-height: 1.7rem;
      &-cancel {
        text-align: center;
        letter-spacing: 0.0024px;
        color: $sub-color;
        margin-right: 1.6rem;
        border: 1.5px solid #12122c;
        box-sizing: border-box;
        border-radius: 0.4rem;
        padding: 1.15rem 2.2rem;
      }
      &-delete {
        color: $white;
        background: #eb5757;
        border-radius: 0.4rem;
        padding: 1.15rem 2.2rem;
      }
    }
  }
  .delete-question {
    margin-bottom: 4.8rem;
  }
  .delete-info {
    margin-bottom: 2rem;
  }
  h1 {
    font-weight: $font-semi-bold;
    font-size: 1.6rem;
    line-height: 2rem;
    margin-bottom: 16px;
    @include screen(menner) {
      font-size: 2rem;
      line-height: 2.4rem;
    }
  }
  p {
    font-size: 1.4rem;
    line-height: 2rem;
    @include screen(menner) {
      font-size: 1.6rem;
      line-height: 2.4rem;
    }
  }
}
.saved-card {
  width: 88%;
  margin-top: 2.5rem;
  background: #ffffff;
  border: 1px solid #d2dce8;
  box-sizing: border-box;
  border-radius: 0.6rem;
  padding: 1.9rem 0 1.9rem 2.8rem;
  display: flex;
  cursor: pointer;
  align-items: center;
  & img {
    margin-right: 3.2rem;
  }
  &:focus {
    border: 1px solid $primary-color;
  }
}
.remember__wrapper {
  display: flex;
  margin-bottom: 3rem;
  color: #5a5a5a;
  font-size: 1.4rem;
  font-weight: $font-light;
  @media screen and (max-width: 576px) {
    justify-content: space-between;
  }
}
.payment__another {
  width: 190px;
  margin: 0;
  cursor: pointer;
  margin: 0 auto;
  font-size: 1.4rem;
  line-height: 1.4rem;
  text-align: center;
  letter-spacing: 0.3px;
  color: $primary-color;
  background: $white;
  border: none;

  &:focus {
    border: 0.1em solid currentColor;
    outline: $primary-color;
  }
  &:disabled{
    opacity: 0.4;
}
  &.otp {
    &:hover {
      text-decoration: underline;
    }
    &:disabled{
       opacity: 0.4;
    }
  }
}
.another-saved, .otp{
    margin: 2rem 0 0px; 
}
.cvv-info {
  &__popup {
    @media screen and (max-width: 576px) {
      height: 100vh;
      z-index: 999;
      overflow: hidden;
      background: $primary-text-color;
      padding: 30vh 5rem 0 5rem;
      position: fixed;
      top: 0;
      left: 0;
      bottom: 0;
      right: 0;
      display: flex;
      flex-direction: column;
      color: white;
    }
  }
  &__img {
    margin: 0 auto;
    margin-bottom: 2.7rem;
  }
  &__main {
    font-family: $font-primary;
    font-size: 1.6rem;
    line-height: 1.8rem;
    padding-bottom: 0.55rem;
    border-bottom: 1px dashed #7c7c7c;
  }
  &__sub {
    font-family:  $font-primary;
    margin-top: 1.71rem;
    margin-bottom: 3.4rem;
    font-size: 1.4rem;
    font-style: italic;
    line-height: 1.8rem;
    color: #e0e0e0;
  }

  &__btn {
    font-family: $font-primary;
    background: $primary-color;
    border-radius: 0.539683rem;
    font-size: 1.78947rem;
    line-height: 105%;
    color: white;
    font-weight: $font-bold;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0.9rem 1.8rem;
    border: none;
    &-wrapper {
      display: flex;
      justify-content: center;
    }
  }
}
.remove-btn {
  border: none;
  background: transparent;
  margin: 2.7rem 0 0 0;
  &:focus {
    border: 1px solid $primary-color;
  }
}
.saved-card-list {
  li {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
}

.resend-disabled {
    color: rgba(51, 51, 51, 0.4);
    font-weight: $font-semi-bold;
    cursor: not-allowed;
    margin: 0 auto;
}
.card--logo {
    margin-top: -30px;
    margin-bottom: 30px;
    padding: 8px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    gap: 5.4px;
    border-radius: 0px 0px 4px 4px;
}
</style>